export default __webpack_public_path__ + "static/media/blue-playlist-icon.541f30c5.svg";